// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import CheckInBaggagePostbooking from '../components/CheckInBaggagePostbooking';
import CheckInBaggagePrimaryFlow from './CheckInBaggagePrimaryFlowContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const CheckInBaggageContainer = ({
  bundleData,
  form,
  includedBaggage,
  isBaggageAvailableOrIncluded,
  isPostBooking,
  isVI = false,
  order,
  orderSecondBag,
  readMore,
  productPosition,
  sellSpecification,
  secondBagProductDetails,
  shouldShowPricePerBound,
  shouldUseCarrierSpecificUnavailableLabel,
  travelerNumber
}) => {
  if (isPostBooking) {
    return /*#__PURE__*/_jsx(CheckInBaggagePostbooking, {
      order: order
    });
  }
  return /*#__PURE__*/_jsx(CheckInBaggagePrimaryFlow, {
    bundleData: bundleData,
    form: form,
    includedBaggage: includedBaggage,
    isBaggageAvailableOrIncluded: isBaggageAvailableOrIncluded,
    isVI: isVI,
    order: order,
    orderSecondBag: orderSecondBag,
    productPosition: productPosition,
    readMore: readMore,
    secondBagProductDetails: secondBagProductDetails,
    sellSpecification: sellSpecification,
    shouldShowPricePerBound: shouldShowPricePerBound,
    shouldUseCarrierSpecificUnavailableLabel: shouldUseCarrierSpecificUnavailableLabel,
    travelerNumber: travelerNumber
  });
};
export default CheckInBaggageContainer;
//# sourceMappingURL=CheckInBaggageContainer.js.map